<template>
  <div >
    <!-- 投入品销售企业 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">投入品销售企业</span>
      </div>
      <div id="echart_quality_one"></div>
    </div>
    <!-- 投入品备案情况统计 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">投入品备案情况统计</span>
      </div>
      <div id="echart_quality_two"></div>
    </div>
    <!-- 投入品年销售额统计 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">投入品年销售额统计</span>
      </div>
      <div id="echart_quality_three"></div>
    </div>
    <!-- 投入品日销售统计 -->
    <div class="echart_zonglans">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">投入品日销售统计</span>
      </div>
      <div class="block">
        <span class="demonstration">选择月份:</span>
        <el-date-picker
          v-model="months"
          type="month"
          value-format="yyyy-MM"
          @change="getMonth()"
          :clearable="false"
          popper-class="backColor"
          prefix-icon="selecticon"
          align="right"
        >
        </el-date-picker>
      </div>
      <div class="div" ref="logo_font">
        <div class="table_border">
          <div v-show="DataMonth" class="monthBox">
            <p>当月数据未更新</p>
          </div>
          <table
            class="table_cont"
            border="1"
            cellpadding="0"
            v-show="!DataMonth"
          >
          <thead>
            <tr
              style="color: #1eeabe; background: #0a4960; border-color: #0a4960"
            >
              <td style="width:30%">日期</td>
              <td style="width:20%">投入品种类</td>
              <td style="width:20%">投入品类别</td>
              <td style="width:20%">销售数量</td>
              <td style="width:10%">明细</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in tableList" :key="index">
              <td style="width:30%">{{ item.sellDate }}</td>
              <td style="width:20%">{{ item.inputKind }}</td>
              <td style="width:20%">{{ item.inputType }}</td>
              <td style="width:20%">{{ item.sellNumber }}</td>
              <td
              style="width:10%"
                @mouseover="mouseOver"
                :style="active"
                @mouseleave="mouseLeave"
                @click="openSales(item.inputType, item.sellDate)"
              >
                查看
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- <p class="text-center">数据来源：{{ Data_txt }}</p> -->
      </div>
      <!--日销售弹窗 -->
      <div class="Sales">
        <el-dialog
          :visible.sync="dialogVisibleSales"
          width="48%"
          :modal="false"
          :close-on-click-modal="false"
          :show-close="false"
          :destroy-on-close="true"
          center
        >
          <span slot="title">
            <span
              style="
                margin-top: 32px;
                height: 32px;
                font-size: 24px;
                font-family: MicrosoftYaHei-Bold;
                color: #3ef89c;
                line-height: 32px;
                letter-spacing: 2px;
              "
              >投入品销售明细</span
            >
          </span>
          <img
            :src="detail_icon_one"
            alt=""
            class="close-icon"
            @click="dialogVisibleSales = false"
          />
          <Salesdialog :inputType="inputType" :sellDate="sellDate" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import Salesdialog from "./productSales.vue";
export default {
  components: {
    Salesdialog,
  },
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      //投入品销售企业
      oneMonth: [
        "城关镇1",
        "城关镇2",
        "城关镇3",
        "城关镇4",
        "城关镇5",
        "城关镇6",
        "城关镇7",
        "城关镇8",
        "城关镇9",
        "城关镇11",
        "城关镇12",
        "城关镇13",
      ],
      oneNumber: [12, 13, 14, 15, 49, 56, 24, 36, 9, 11, 19, 37, 39],

      // 投入品备案情况
      twoMonth: [
        "城关镇1",
        "城关镇2",
        "城关镇3",
        "城关镇4",
        "城关镇5",
        "城关镇6",
        "城关镇7",
        "城关镇8",
        "城关镇9",
        "城关镇11",
        "城关镇12",
        "城关镇13",
      ],
      twoNumber: [12, 13, 14, 15, 49, 56, 24, 36, 9, 11, 19, 37, 39],

      // 投入品年销售统计
      threeData: [],

      // 投入品日销售统计
      DataMonth: false,
      months: "",
      logo_font: require("@/assets/images/蒙版组 18.png"),
      logo_i: require("@/assets/images/路径 28799.png"),
      tableList: [],
      active: "",
      // 明细弹窗
      dialogVisibleSales: false,
      sellDate: "",
      inputType: "",
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
      // 数据来源
      Data_txt: "",
    };
  },
  mounted() {
    this.skMonthrangeDefault();
    this.init_one();
    this.init_two();
    this.init_three();
    this.getMonth();
  },
  methods: {
    // 投入品销售企业
    init_one() {
      // 调取接口
      var data_beian = plOtherDataInterface.getInputCompanyWithVillageList();
      this.oneMonth = data_beian.names;
      this.oneNumber = data_beian.numbers;

      var myChart = echarts.init(document.getElementById("echart_quality_one"));
      var option = {
        color: ["#FDB628"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            console.log(params);
            return `
              <div style="font-size:12px;">${params[0].name}<br>投入品销售企业：${params[0].data}${params[0].seriesName}</div>
            `;
          },
        },
        grid: {
          left: "4%",
          right: "4%",
        },
        xAxis: [
          {
            type: "category",
            data: this.oneMonth,
            axisLabel: {
              show: true,
              interval: 0, //设置间隔为0
              textStyle: {
                color: "#fff",
                fontSize:16
              },
              formatter: function (value) {
                var ret = ""; //拼接加\n返回的类目项
                var maxLength = 3; //每项显示文字个数
                var valLength = value.length; //X轴类目项的文字个数
                var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                if (rowN > 1) {
                  //如果类目项的文字大于5,
                  for (var i = 0; i < rowN; i++) {
                    var temp = ""; //每次截取的字符串
                    var start = i * maxLength; //开始截取的位置
                    var end = start + maxLength; //结束截取的位置
                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    temp = value.substring(start, end) + "\n";
                    ret += temp; //凭借最终的字符串
                  }
                  return ret;
                } else {
                  return value;
                }
              },
            },
            axisTick: {
              //x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位（个）",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "个",
            type: "bar",
            barWidth: 30, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            data: this.oneNumber,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 投入品备案情况统计
    init_two() {
      // 接口
      var data_heke = plOtherDataInterface.getNetPointRecordStaticList();
      this.twoMonth = data_heke.names;
      this.twoNumber = data_heke.numbers;

      var myChart = echarts.init(document.getElementById("echart_quality_two"));
      var option = {
        color: ["#B6A2DE"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return `
              <div style="font-size:12px;">${params[0].name}<br>投入品备案：${params[0].data}${params[0].seriesName}</div>
            `;
          },
        },
        grid: {
          left: "4%",
          right: "4%",
        },
        xAxis: [
          {
            type: "category",
            data: this.twoMonth,
            axisLabel: {
              show: true,
              interval: 0, //设置间隔为0
              textStyle: {
                color: "#fff",
                fontSize:16
              },
              formatter: function (value) {
                var ret = ""; //拼接加\n返回的类目项
                var maxLength = 3; //每项显示文字个数
                var valLength = value.length; //X轴类目项的文字个数
                var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                if (rowN > 1) {
                  //如果类目项的文字大于5,
                  for (var i = 0; i < rowN; i++) {
                    var temp = ""; //每次截取的字符串
                    var start = i * maxLength; //开始截取的位置
                    var end = start + maxLength; //结束截取的位置
                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    temp = value.substring(start, end) + "\n";
                    ret += temp; //凭借最终的字符串
                  }
                  return ret;
                } else {
                  return value;
                }
              },
            },
            axisTick: {
              //x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位（个）",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "个",
            type: "bar",
            barWidth: 25, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            data: this.twoNumber,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 投入品年销售统计
    init_three() {
      // 接口
      var data_jingying = plOtherDataInterface.getInputYearSellStaticList();
      var list = [];
      data_jingying.forEach((element) => {
        list.push([
          element.theYear,
          element.orgPriceSell,
          element.realPriceSell,
          element.settledSell,
          element.noSettledSell,
        ]);
        let aa = list.length;
        this.threeData = list.slice(0, aa - 1);
      });
      var myChart = echarts.init(
        document.getElementById("echart_quality_three")
      );
      var option = {
        color: ["#6FC5FF", "#CEFD65", "#3FC7BE", "#FB7960"],
        legend: {
          data: ["原价销售总额", "应销售总额", "已结算销售额", "未结算金额"],               
          textStyle: { color: "#fff",fontSize:16 },
          x: "right", //居右显示
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var showHtm = params[0].name+ "<br>" ;
            for (var i = 0; i < params.length; i++) {
              showHtm += params[i].seriesName+":"+params[i].data[i+1]+"元"+"<br>"
            }
            return showHtm;
          },
        },
        dataset: {
          source: this.threeData,
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: true,
            interval: 0, //设置间隔为0
            textStyle: {
              color: "#fff",
              fontSize:16
            },
          },
          axisTick: {
            //x轴刻度线
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: ["#ccc"],
              width: 1,
              type: "dashed",
            },
          },
        },
        yAxis: [
          {
            name: "单位（元）",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          { type: "bar", name: "原价销售总额" },
          { type: "bar", name: "应销售总额" },
          { type: "bar", name: "已结算销售额" },
          { type: "bar", name: "未结算金额" },
        ],
      };
      option && myChart.setOption(option);
    },
    // 投入品日销售统计
    // 对应月份换数据
    getMonth() {
      console.log(this.months);
      var data = plOtherDataInterface.getEveryDaySellInfoWithTypeByMonthList(
        this.months
      );
      // 为空显示暂无数据
      if (!data) {
        this.DataMonth = true;
      } else {
        this.tableList = data;
        console.log(this.tableList);
        this.DataMonth = false;
      }
    },
    skMonthrangeDefault() {
      let date = {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
      };
      this.months = date.year + "-" + '0'+date.month;
    },
    // 移入移出查看按钮变色
    mouseOver() {
      //改变样式
      this.active = "color：#55F8FF; cursor: pointer;";
    },
    mouseLeave() {
      //清空样式
      this.active = "cursor: pointer;";
    },
    openSales(a, b) {
      this.inputType = a;
      this.sellDate = b;
      this.dialogVisibleSales = true;
    },
  },
};
</script>
<style lang="less" scoped>
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-bottom: 1px dashed rgb(121, 226, 154);
  padding-top: 1.875rem;
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  padding-top: 1.875rem;
}
#echart_quality_three,
#echart_quality_two,
#echart_quality_one,
#echart_quality_four {
  height: 18.75rem;
}
.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */

// 列表样式
.div {
  background: #15606e;
}
.logo_img {
  width: 6.25rem;
  height: 1.575rem;
  margin-top: 1.25rem;
}
.logo_icon {
  position: absolute;
  right: 0.625rem;
  top: 1.25rem;
  width: 1.0625rem;
  height: 1.0625rem;
  cursor: pointer;
}
.logo_font {
  padding-bottom: 1.875rem;
  position: relative;
}
.table_border {
  padding: 20px 20px 5px;
  height: auto;
}
.border_height {
  padding: 35px 20px 10px;
}
.table {
  background: #0a4960;
  color: rgb(125, 243, 164);
  font-size: 1.2rem;
  width: 100%;
  text-align: center;
}

table tbody {
    display: block;
    max-height: 400px;            
    overflow-y: auto;
}
table thead,
tbody tr {
    display: table;
    table-layout: fixed; /* 使用表格固定算法 必须配合上面一起使用 */
    width: 100%;
    text-align: center; 
}
.table_cont {
  color: #fff;
  font-size: 16px;
  border-color: #83aabe;
     border-collapse: collapse;
  td {
    padding: 10px 0;
  }
}
.monthBox {
  width: 100%;
  text-align: center;
  p {
    font-size: 30px;
    color: #fff;
  }
}
.demonstration {
  color: #fff;
  font-size: 17px;
}
/deep/.block {
  margin-top: 15px;
  text-align: right;
  padding-right: 25px;
}
/deep/.el-date-editor.el-input {
  width: 130px;
}
/deep/.el-input__inner {
  height: 27px;
  background: #39819a;
  color: #fff;
  border: 1px solid #39819a;
  cursor: pointer;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 22px;
}
/deep/.el-input__icon {
  line-height: 27px;
}
/deep/.el-picker-panel {
  background-color: #15606e !important;
  left: 1111px !important;
}
/deep/.el-month-table td .cell {
  color: #fff !important;
}
/deep/.el-picker-panel__icon-btn,
.el-date-picker__header-label {
  color: #fff !important;
}
.selecticon {
  display: none;
}
// 明细弹窗样式
/deep/.el-dialog {
  margin-top: 30vh !important;
  background: #104853;
  border: 1px solid #008f82;
}
.close-icon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 25px;
  right: 41px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_quality/inputProduct.vue